<template>
  <div v-if="!noContent" class="left-chart-bottom mb-sm-4 mt-6 mt-sm-0">
    <h6 class="chart-title">
      {{ $t('dashboard.titles.calendar') }}
    </h6>
    <div class="settings-tab">
      <div class="left-bottom-list-wrap">
        <template v-for="(event, i) in tickerCalendar">
          <div
            class="divider"
            :key="'d' + i"
            v-if="
              tickerCalendar[i].isOld &&
                (!tickerCalendar[i - 1] ||
                  (tickerCalendar[i - 1] && !tickerCalendar[i - 1].isOld))
            "
            @click="oldOpened = !oldOpened"
          >
            <div class="line"></div>
            <div class="text">
              {{ $t('dashboard.events.old') }}
              <i-arrow class="arrow" :class="{ up: oldOpened }" />
            </div>
            <div class="line"></div>
          </div>
          <div class="single-footer-chart-list" v-if="oldOpened" :key="i">
            <a :href="event.link" target="blank" rel="noreferrer">
              <h6 class="ml-0">
                <span style="color: grey">{{ event.date }}</span>
                {{ event.title }}
              </h6>
            </a>
          </div>
        </template>
      </div>
      <div class="settings-tab-overlay multi-collapse collapse"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import iarrow from '@/components/icons/arrow'

export default {
  data() {
    return {
      oldOpened: false,
    }
  },
  computed: {
    noContent() {
      return this.tickerCalendar.length === 0
    },
    ...mapState('ticker', {
      tickerCalendar(state) {
        const now = +new Date()
        return state.events
          .map((el) => ({
            ...el,
            date: new Date(el.date),
          }))
          .sort((a, b) => {
            return b.date - a.date
          })
          .map((el) => ({
            ...el,
            date: new Intl.DateTimeFormat(this.$i18n.locale).format(el.date),
            isOld: +el.date < now,
          }))
      },
    }),
  },
  components: {
    'i-arrow': iarrow,
  },
}
</script>

<style lang="scss">
.left-chart-bottom .divider {
  display: flex;
  justify-content: stretch;
  align-items: center;
  flex-direction: row;
  gap: 20px;
  padding: 0 3px;

  > .line {
    height: 1px;
    background: #c2c2d6;
    flex-grow: 1;
  }
  > .text {
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.single-footer-chart-list + .divider {
  margin-top: -10px;
}
</style>
